import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import { Provider } from 'react-redux';
import { persistor, store } from 'src/redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import { AuthContextProvider } from './contexts/authContext';
import './i18n';
import Swal from 'sweetalert2';
import axios from 'axios';

const children = (
	<AuthContextProvider>
		<ThemeContextProvider>
			<Router>
				<React.StrictMode>
					<Provider store={store}>
						<PersistGate loading={null} persistor={persistor}>
							<App />
						</PersistGate>
					</Provider>
				</React.StrictMode>
			</Router>
		</ThemeContextProvider>
	</AuthContextProvider>
);

axios.interceptors.response.use(undefined, function (error) {
	// let expired = getStorage("expired");
	// let current = parseInt(Date.now() / 1000);

	// console.log("expired =>",(expired && current > expired));

	// console.log("res =>",error.response.status );

	if (error.response.status == 401) {
		sessionStorage.clear();
		localStorage.clear();
		window.location.replace(`${window.location.origin}/login`);
	}

	return Promise.reject(error);
});

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
